// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Callout-module__ui-Callout--f90_w {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  min-height: 39px;
  align-items: center;
  gap: 7px;
  margin: 0;
  padding: 0 12px;
  border-radius: 4px;
  background-color: #f6f2ec;
  color: #1a1a1a;
  font-size: 0.875rem; /* 14px */
  font-weight: 400;
  line-height: normal;
  overflow-wrap: anywhere;
}

.Callout-module__leading--ZB7nt {
  display: inline-flex;
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
  align-items: center;
  justify-content: center;
}

.Callout-module__leading--ZB7nt > :where(img, svg) {
  display: block;
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Callout/Callout.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd","sourcesContent":[".ui-Callout {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  min-height: 39px;\n  align-items: center;\n  gap: 7px;\n  margin: 0;\n  padding: 0 12px;\n  border-radius: 4px;\n  background-color: #f6f2ec;\n  color: #1a1a1a;\n  font-size: 0.875rem; /* 14px */\n  font-weight: 400;\n  line-height: normal;\n  overflow-wrap: anywhere;\n}\n\n.leading {\n  display: inline-flex;\n  width: 14px;\n  height: 14px;\n  flex: 0 0 14px;\n  align-items: center;\n  justify-content: center;\n}\n\n.leading > :where(img, svg) {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Callout": `Callout-module__ui-Callout--f90_w`,
	"leading": `Callout-module__leading--ZB7nt`
};
export default ___CSS_LOADER_EXPORT___;
